<!-- 左侧菜单 -->
<template>
  <div class="menu_box move" :class="{'to_close':isChange}">
    <div class="all">
      <!-- 展开菜单 -->
      <div class="full_menu" ref="full_menu" v-if="!isChange">
        <div class="menu_detail">
          <div v-for="(item,index) in totalMenu" :key="index" class="menu_border">
            <a class="menu_item" :class="{'active':menuIndex===index}" @click="chooseMenu(index)"
               @mouseenter="hoverEvent(index)" @mouseleave="hoverEvent('')"
               v-right-click="{rightMenuObj,url:`${(item.childList && item.childList.length) ? item.childList[0].url : item.url}?key=${(item.childList && item.childList.length) ? item.childList[0].uniqueCode : item.uniqueCode}`}">
              <div>
                <!-- <img
                  v-if="item.icon"
                  :src="require('../../assets/img/menu/'+item.icon+(menuIndex===index||hoverIndex===index?'_fill.png':'.png'))"
                  class="choose_icon"/> -->
                  <template v-if="item.icon">
                    <el-image v-show="item.icon && menuIndex===index||hoverIndex===index" class="choose_icon" :src="require('../../assets/img/menu/'+item.icon+'_fill.png')">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                    <el-image v-show="item.icon && !(menuIndex===index||hoverIndex===index)" class="choose_icon" :src="require('../../assets/img/menu/'+item.icon+'.png')">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </template>
              </div>
              <span class="item_name">
                {{ languageId === 1 ? item.name : item.englishName }}
                <i v-if="item.childList&&Object.keys(item.childList).length!==0"
                   :class="menuIndex===index?'el-icon-caret-bottom':'el-icon-caret-right'"></i>
              </span>
            </a>
            <div class="second_box" id="second" v-if="menuIndex===index">
              <div class="second_line" v-for="(sitem,sindex) in item.childList" :key="sindex">
                <a @click="chooseSecond(index,sindex,sitem.url,sitem.uniqueCode)"
                   v-right-click="{rightMenuObj,url:`${sitem.url}?key=${sitem.uniqueCode}`}"
                   :class="{'second_choose':secondIndex===sindex}">{{
                    languageId === 1 ? sitem.name : sitem.englishName
                  }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 收缩后菜单 -->
      <div class="short_menu" ref="short_menu" v-else>
        <div v-for="(item,index) in totalMenu" :key="index" @click="chooseMenu(index)" @mouseenter="hoverEvent(index)"
             @mouseleave="hoverEvent('')">
          <a>
            <!-- <img
              :src="require('../../assets/img/menu/'+item.icon+(menuIndex===index||hoverIndex===index?'_fill.png':'.png'))"
              class="choose_icon"/> -->
              <template v-if="item.icon">
                <el-image v-show="item.icon && menuIndex===index||hoverIndex===index" class="choose_icon" :src="require('../../assets/img/menu/'+item.icon+'_fill.png')">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <el-image v-show="item.icon && !(menuIndex===index||hoverIndex===index)" class="choose_icon" :src="require('../../assets/img/menu/'+item.icon+'.png')">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </template>
          </a>
        </div>
      </div>
      <!-- 收缩按钮 -->
      <div class="switch_btn" @click="changeSwitch(!isChange)">
        <i class="el-icon-d-arrow-left" v-if="!isChange"></i>
        <i class="el-icon-d-arrow-right" v-else></i>
      </div>
    </div>

    <!--右键菜单-->
    <div
      id="rightMenuDom"
      class="right-menu"
      :style="{
        display: rightMenuStatus,
        top: rightMenuTop,
        left: rightMenuLeft
      }">
      <ul>
        <li>
          <span
            v-for="item in rightMenuList"
            :key="item.id"
            @click="item.handler(item.url)"
          >{{ item.text }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import {getFirst, getSecond, getWebIndex, setFirst, setSecond} from "../../utils/menuIndex";
import {getTree} from "../../utils/menuAuth";
import {mixins} from "../../utils/mixins";
import { clearBtnAuth } from "../../utils/btnAuth";

export default {
  mixins: [mixins],
  data() {
    return {
      menuIndex: getFirst(),
      secondIndex: getSecond(),
      hoverIndex: '',
      totalMenu: [],
      isChange: false,
      menuLeft: 0,
      menuTop: 0,
      rightMenu: {
        status: 'none',
        top: '0px',
        left: '0px',
        menus: [
          {
            id: 1,
            text: '在新窗口中打开',
            callBack: this.gotoPage
          }]
      },
      // 右键菜单对象，菜单内容和处理事件
      rightMenuObj: {
        text: [
          "在新窗口中打开",
        ],
        handler: {
          gotoPage(url) {
            window.open(url, '_blank');
          },
        }
      }
    }
  },
  computed: {
    // 右键菜单显隐状态
    rightMenuStatus() {
      return this.$store.state.rightMenu.status;
    },
    // 右键菜单距离浏览器顶部高度
    rightMenuTop() {
      return this.$store.state.rightMenu.top;
    },
    // 右键菜单距离浏览器左边长度
    rightMenuLeft() {
      return this.$store.state.rightMenu.left;
    },
    // 右键菜单列表内容
    rightMenuList() {
      return this.$store.state.rightMenu.list || [];
    }
  },
  created() {
    this.listenToClick();
    this.initMenu();
  },
  methods: {
    // 监听菜单点击事件
    listenToClick(){
      // 监听全局点击事件
      document.addEventListener("click", () => {
        this.$store.commit("updateRightMenuStatus", {
          status: "none",
          left: "0px",
          top: "0px"
        });
      });
    },

    // 菜单数据初始化
    initMenu(){
      // 获取左侧菜单
      if (getTree()) {
        let m = JSON.parse(getTree());
        if (m.length !== 0) {
          this.totalMenu = m;
        }
      } else {
        this.$store.commit('SET_BTN_AUTH', null);
        this.$store.commit('SET_ALL_BTN_AUTH', {});
        clearBtnAuth();
        this.$router.push('/')
      }
      //获取当前菜单索引
      let one = getFirst();
      let two = getSecond();
      this.menuIndex = one ? parseInt(one) : this.menuIndex;
      this.secondIndex = two ? parseInt(two) : this.secondIndex;
    },

    // 一级菜单选择
    chooseMenu(e) {
      let that = this;
      let param = !that.totalMenu[e].childList || that.totalMenu[e].childList.length === 0;
      let url = param ? that.totalMenu[e].url : that.totalMenu[e].childList[0].url;
      let id = param ? that.totalMenu[e].uniqueCode : that.totalMenu[e].childList[0].uniqueCode;
      that.changeSwitch(false);
      if (url) {
        // if (that.menuIndex === e) {
        //   that.menuIndex = '';
        // } else {
          that.setIndex(e, 0);
          // 没有子类时，直接跳转，有子类时，跳到第一个
          if (that.$route.path !== url) {
            that.$router.push({
              path: (url && url.substring(0, 1) === '/' ? url : '/' + url),
              query: {
                key: id,
              }
            })
          }
        // }
      } else {
        that.$notify({
          title: that.languageId === 1 ? '提示' : 'Tip',
          message: that.languageId === 1 ? '该菜单下暂无子菜单！' : 'There are currently no submenus under this menu!',
          position: 'bottom-left',
          showClose: false,
          duration: 1500,
          type: 'warning'
        });
      }
    },

    // 二级菜单选择
    chooseSecond(findex, sindex, url, id) {
      this.setIndex(findex, sindex);
      if (this.$route.fullPath !== (url + '?key=' + id)) {
        this.$router.push({
          path: url,
          query: {
            key: id,
          }
        });
      }
    },

    hoverEvent(index) {
      this.hoverIndex = index;
    },

    // 设置菜单索引值
    setIndex(first, second) {
      this.menuIndex = first;
      this.secondIndex = second;
      setFirst(first);
      setSecond(second);
    },

    changeSwitch(is) {
      this.isChange = is;
      this.$emit('listenToMenu', is)
    },
  },

  watch: {
    //跳转高亮显示
    '$route': {
      handler(newR, oldR) {
        //判断是否是跳转
        let href = window.location.href;
        if (href.indexOf('key') < 0) {
          return;
        }
        // 回显
        let data = getWebIndex(newR.query.key);
          this.menuIndex = data.first;
          this.secondIndex = data.second;
      },
      immediate: true,
      deep: true
    },
  }
}
</script>

<style scoped>
.menu_box {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 214px;
  z-index: 1;
  padding-top: 60px;
  background-color: #000;
}

.to_close {
  left: -154px;
}

.full_menu {
  padding: 40px 0;
}

.to_close {
  left: -154px;
}

.all {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.switch_btn {
  position: absolute;
  right: 0;
  top: 58%;
  padding: 10px 0;
  background: #f2f2f2;
  cursor: pointer;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.menu_detail {
  color: #fff;
}

.menu_border{
  padding-left: 10px;
}

.menu_item {
  height: 40px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  box-sizing: border-box;
  padding-left: 10px;
}

.menu_item i {
  font-size: 16px;
  margin-left: 8px;
  color: #fff;
}

.menu_item div {
  display: flex;
  align-items: center;
  width: 24px;
  height: 24px;
  justify-content: center;
}

.menu_item div .choose_icon {
  width: 20px;
  height: 20px;
  transition: all 0.3s;
}

.item_name {
  display: flex;
  align-items: center;
  margin-left: 5px;
  letter-spacing: 1px;
}

.menu_item:hover {
  color: #3970e3;
  background: rgba(209, 240, 255, 0.3);
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.menu_item:hover i {
  color: #3970e3;
}

.active {
  color: #3970e3;
  background: #F0F2F5!important;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.active i {
  color: #3970e3;
}

.second_box {
  color: #fff;
  padding-left: 40px;
  text-align: left;
  font-size: 14px;
  /*background: #030619;*/
}

.second_box a {
  display: flex;
  align-items: center;
  /*line-height: 40px;*/
  height: 40px;
  cursor: pointer;
  color: #c1c1c1;
}

.second_box a:hover {
  color: #3970e3;
}

.second_box .second_choose {
  color: #3970e3;
}

.second_line div a {
  display: block;
  line-height: 40px;
  height: 40px;
  padding-left: 20px;
  color: #999999;
  cursor: pointer;
}

.second_line i {
  margin-right: 6px;
  font-size: 16px;
}

.short_menu {
  position: absolute;
  right: 0;
  top: 0;
  width: 60px;
}

.short_menu a {
  height: 60px;
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.short_menu .choose_icon {
  width: 28px;
}

.right-menu {
  position: fixed;
  left: 0;
  top: 0;
  width: 140px;
  height: auto;
  background-color: rgb(242, 242, 242);
  border: solid 1px #C2C1C2;
  display: none;
  border-radius: 5px;
}

.right-menu ul {
  padding: 0;
  margin: 0;
  font-size: 14px;
}

.right-menu ul li {
  list-style: none;
  box-sizing: border-box;
  padding: 2px 0;
  border-bottom: 1px solid rgb(216, 216, 217);
}

.right-menu ul li:nth-child(1) {
  padding-top: 2px;
}

.right-menu ul li:nth-last-child(1) {
  border-bottom: none;
}

.right-menu ul li span {
  display: block;
  height: 20px;
  line-height: 20px;
  padding-left: 16px;
}

.right-menu ul li span:hover {
  background-color: #0070F5;
  cursor: pointer;
  color: #FFFFFF;
}
</style>




// WEBPACK FOOTER //
// src/components/menu/index.vue